import { Alert as AlertComponent } from '@change/ds-core-ui';

type Props = {
	error?: {
		title: string;
		description: string;
	};
};

export const Alert: React.FC<Props> = ({ error }) => {
	if (!error) return null;
	return (
		<AlertComponent variant="error" heading={error.title} data-qa="stripe-form-error-message">
			{error.description}
		</AlertComponent>
	);
};
